import React, { useEffect, useState } from 'react';

import { PatientDetails } from '../../components/common/patientDetails';

import {
    clearData,
    removingPageNumber
} from '../../services/slices/dispense/vitalPatients';

import {
    onhandleConfirmDelivery,
} from '../../utils/helper/deliveriesHelper';

import { handleToggleRXData } from '../../utils/helper/helper';
import { useAuthSelector } from '../../services/selectors/authSelector';

import { useAllSelector } from '../../services/selectors/allSelector';
import { ErrorMessages } from '../../components/error/errorMessages';
import { fetchVitalPatients } from '../../services/apis/dispense/vitalPatients';

import { useCustomStates } from '../../hooks/useCustomStates';
import { DispenseRxData } from '../../components/common/dispenseRxData';
import DriverAppointmentCallPanel from '../../components/common/driverAppointmentCallPanel';

import { RemoveAllPatchesId } from '../../services/slices/dispense/validateReturnPatches';
import { clearConfirmDeliveryUserMessage } from '../../services/slices/dispense/confirmDelivery';

import InfiniteScroll from 'react-infinite-scroll-component';

import * as Messages from '../../components/common/AllConfirmationMessages'
import * as routeNames from '../../routes/routeName'
import * as Icons from '../../assets/svg/icons';
import * as Common from '../../components/common';

import * as Hooks from '../../hooks';
import * as Loading from '../../components/common/loader'

import PageNotFound from '../notFound/pageNotFound';

const VitalPatients = () => {

    const dispatch = Hooks.useCustomDispatch();
    const navigate = Hooks.useCustomNavigate();

    const { pharmacyId, pharmacyInspectionMode, hcpUser } = useAuthSelector()
    const { vitalPatientsResponse, validateReturnedPatchesResponse, pharmacist_assistant_status, confirmDeliveryResponse } = useAllSelector();

    const { comment,
        setComment,

        cordinate,

        isRefused,
        setIsRefused,

        openIndex,
        setOpenIndex,

        patientSignature,
        setPatientSignature,

        pharmacistSignature,
        setPharmacistSignature,

        showErrorToast,
        setShowErrorToast,

        loading,
        setLoading,

        showSuccessToast,
        setShowSuccessToast,

        showComment,
        setShowComment,

        showPatientSignature,
        setShowPatientSignature,

        showPharmacistSignature,
        setShowPharmacistSignature,

        showData,
        setShowData,

        signatureErrors,
        setSignatureErrors,

        covid19,
        setCovid19,

        isTransferRequest,
        setIsTransferRequest,

        loadMore,
        setLoadMore,

        setPId,

        consultation,
        setConsultation,

        newRxCounsellingValues,
        setNewRxCounsellingValues,

        isPatientVerified,
        setIsPatientVerified,

        setMissedExplanation,
        setMissedExplanationError,

        selectedDoses,
        setSelectedDoses,

        unconsumedDoseEntries,
        setUnconsumedDoseEntries,

        unconsumedDoseErrors,
        setUnconsumedDoseErrors
    } = useCustomStates()

    const [flexiProofImages, setFlexiProofImages] = useState({})
    const [copayPaymentOptions, setCopayPaymentOptions] = useState({})
    const [selectedDeliverRxIds, setSelectedDeliverRxIds] = useState([])
    const { getMatchedAppointmentDelivery } = Hooks.useTodayAppointmentDeliveryMap({
        pharmacyId,
        enabled: Boolean(
            pharmacyId &&
            hcpUser !== 0 &&
            !vitalPatientsResponse?.loading &&
            Array.isArray(vitalPatientsResponse?.data) &&
            vitalPatientsResponse.data.length > 0
        ),
        refreshKey: 'add-vitals',
    })

    const handleDropdownToggle = (index, data) => {
        setConsultation(null)
        setNewRxCounsellingValues([])
        setSelectedDoses({})
        if (openIndex !== index) {
            const rxData = data?.patients_win_rx_data?.length > 0 ? data?.patients_win_rx_data : data?.active_rx_data
            const rxIds = rxData?.map((r) => r.id).filter(Boolean) || []
            setSelectedDeliverRxIds(rxIds)
        }
        handleToggleRXData(
            index,
            data,
            openIndex,
            setOpenIndex,
            dispatch,
            setSignatureErrors,
            setShowData,
            RemoveAllPatchesId,
            setPatientSignature,
            setShowComment,
            setShowPatientSignature,
            setShowPharmacistSignature,
            setPharmacistSignature,
            setComment,
            setIsPatientVerified,
            setUnconsumedDoseEntries,
            setUnconsumedDoseErrors,
            setMissedExplanation,
            setMissedExplanationError,
            setPId,
            pharmacyId
        )
    }

    useEffect(() => {
        if (pharmacyId) {
            setLoading(true)
            dispatch(clearData())
            dispatch(removingPageNumber())
            const params = {
                page: 1,
                pharmacy_id: pharmacyId,
                setLoading: setLoading,
            }
            dispatch(fetchVitalPatients(params))
        }
        return () => { }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pharmacyId])

    const handleConfirmDelivery = (patientData, index) => {
        onhandleConfirmDelivery(patientData,
            index,
            pharmacyId,
            null,
            patientSignature,
            pharmacistSignature,
            cordinate,
            comment,
            dispatch,
            setLoading,
            setOpenIndex,
            setShowErrorToast,
            setShowSuccessToast,
            pharmacyInspectionMode,
            isRefused,
            covid19,
            'add_vital',
            setIsRefused,
            setSignatureErrors,
            validateReturnedPatchesResponse,
            isTransferRequest,
            setIsTransferRequest,
            pharmacist_assistant_status,
            consultation,
            newRxCounsellingValues,
            selectedDoses,
            flexiProofImages,
            copayPaymentOptions,
            null,
            isPatientVerified,
            selectedDeliverRxIds,
            unconsumedDoseEntries,
            setUnconsumedDoseErrors
        );
    }

    const fetchMoreData = () => {
        if (vitalPatientsResponse?.currentPage < vitalPatientsResponse?.totalPages) {
            setLoadMore(true)
            const params = {
                page: vitalPatientsResponse?.currentPage + 1,
                pharmacy_id: pharmacyId,
                setLoading: setLoading,
                setLoadMore: setLoadMore
            }
            dispatch(fetchVitalPatients(params))
        }
    }


    return (
        <>
            {pharmacyId ? <>
                {vitalPatientsResponse?.data?.length > 0 &&
                    <InfiniteScroll
                        dataLength={vitalPatientsResponse?.data?.length}
                        next={fetchMoreData}
                        hasMore={vitalPatientsResponse?.currentPage <= vitalPatientsResponse?.totalPages}
                    />
                }

                <div className="app-wrapper flex justify-center">
                    <div className="app-screen no-shades w-full xl:w-3/12 lg:w-4/12 md:w-5/12 sm:w-6/12 h-full overflow-x-hidden">
                        <div className="relative p-4" >
                            <Common.TopBar />

                            <div className="title-row my-2 flex items-center justify-between gap-3" >
                                <h1 className="text-xl font-bold">Add Vitals</h1>
                                <button onClick={() => navigate(`${routeNames.DASHBOARD_PHARMACY}`)}>
                                    <Icons.HomeIcon />
                                </button>
                            </div>

                            <div className="routes-list">

                                {(vitalPatientsResponse?.loading && loading) ?

                                    <div className='flex justify-center h-96'>
                                        <Loading.LoadingView />
                                    </div> :

                                    vitalPatientsResponse?.error !== null ?
                                        <div className='flex  justify-center pb-4 mb-4'>
                                            <ErrorMessages error={'Oops! Got an issue while fetching Data.Please try again!'} />
                                        </div> :

                                        (vitalPatientsResponse?.data?.length === 0 && !vitalPatientsResponse?.loading) ?
                                            <p className='flex  justify-center pb-4 pt-3 h-96'>No patients found.</p>
                                            :

                                            vitalPatientsResponse?.data?.map((data, index) => {
                                                const isDeliveryActionVisible = hcpUser !== 0 && !(data?.active_rx_data?.length > 0 || (data?.active_rx_data?.length === 0 && data?.patients_win_rx_data?.length === 0));
                                                const appointmentDelivery = isDeliveryActionVisible ? getMatchedAppointmentDelivery(data) : null;
                                                return (

                                                <React.Fragment key={index}>

                                                    <div className="card bg-white px-4 py-3 rounded-lg shadow-sm mb-3" id={`patientCard-${index}`}>
                                                        <PatientDetails
                                                            data={data}
                                                            patientImg={data.profile_image}
                                                            totalRxData={data?.patients_win_rx_data?.length || data?.active_rx_data?.length}
                                                            index={index}
                                                            openIndex={openIndex}
                                                            onDropdownToggle={handleDropdownToggle}
                                                        >
                                                            <>
                                                                <DispenseRxData
                                                                    rxData={data?.patients_win_rx_data?.length > 0 ? data?.patients_win_rx_data : data?.active_rx_data}
                                                                    signatureErrors={signatureErrors}
                                                                    type="new_rx"
                                                                    newRxCounsellingValues={newRxCounsellingValues}
                                                                    setNewRxCounsellingValues={setNewRxCounsellingValues}
                                                                    patientData={data}
                                                                    selectedDoses={selectedDoses}
                                                                    setSelectedDoses={setSelectedDoses}
                                                                    flexiProofImages={flexiProofImages}
                                                                    setFlexiProofImages={setFlexiProofImages}
                                                                    copayPaymentOptions={copayPaymentOptions}
                                                                    setCopayPaymentOptions={setCopayPaymentOptions}
                                                                    setOpenIndex={setOpenIndex}
                                                                    selectedDeliverRxIds={selectedDeliverRxIds}
																	setSelectedDeliverRxIds={setSelectedDeliverRxIds}
                                                                    unconsumedDoseEntries={unconsumedDoseEntries}
                                                                    setUnconsumedDoseEntries={setUnconsumedDoseEntries}
                                                                    unconsumedDoseErrors={unconsumedDoseErrors}
                                                                    setUnconsumedDoseErrors={setUnconsumedDoseErrors}
                                                                    showAddVitalButton={data?.active_rx_data?.length > 0 || (data?.active_rx_data?.length === 0 && data?.patients_win_rx_data?.length === 0)}
                                                                />

                                                                {showData &&
                                                                    <React.Fragment>
                                                                        <Common.Comment showComment={showComment}
                                                                            setShowComment={setShowComment}
                                                                            setComment={setComment} comment={comment} />

                                                                        <Common.DeliveryConsultationDropdown consultation={consultation}
                                                                            setConsultation={setConsultation} />

                                                                        <Common.PatientSignature patientSignature={patientSignature}
                                                                            setPatientSignature={setPatientSignature}
                                                                            showPatientSignature={showPatientSignature}
                                                                            setShowPatientSignature={setShowPatientSignature}
                                                                            isRefused={isRefused}
                                                                            setIsRefused={setIsRefused}
                                                                            isPatientVerified={isPatientVerified}
                                                                            setIsPatientVerified={setIsPatientVerified}
                                                                            signatureErrors={signatureErrors}
                                                                            setSignatureErrors={setSignatureErrors}
                                                                            covid19={covid19}
                                                                            setCovid19={setCovid19}
                                                                            rxData={data?.patients_win_rx_data}
                                                                        />

                                                                        {pharmacist_assistant_status === 1 ? null :
                                                                            <Common.PharmacistSignature
                                                                                pharmacistSignature={pharmacistSignature}
                                                                                setPharmacistSignature={setPharmacistSignature}
                                                                                showPharmacistSignature={showPharmacistSignature}
                                                                                setShowPharmacistSignature={setShowPharmacistSignature}
                                                                                signatureErrors={signatureErrors}
                                                                                setSignatureErrors={setSignatureErrors}
                                                                            />}


                                                                    </React.Fragment>
                                                                }

                                                                {hcpUser === 0 || (data?.active_rx_data?.length > 0 || (data?.active_rx_data?.length === 0 && data?.patients_win_rx_data?.length === 0)) ?
                                                                    null
                                                                    :
                                                                    (() => {
                                                                        const noRxSelected = !selectedDeliverRxIds || selectedDeliverRxIds.length === 0;
                                                                        return (
                                                                            <div className="flex items-center gap-3">
                                                                                {showData ?
                                                                                    
                                                                                        <button
                                                                                            className={`px-4 flex-1 py-2 rounded-md ${noRxSelected || confirmDeliveryResponse?.loading ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
                                                                                            disabled={noRxSelected || confirmDeliveryResponse?.loading}
                                                                                            onClick={() => {
                                                                                                if (noRxSelected || confirmDeliveryResponse?.loading) return;
                                                                                                handleConfirmDelivery(data, index);
                                                                                            }}>
                                                                                            {confirmDeliveryResponse?.loading ? <p className='flex justify-center items-center'><Loading.Loader /></p> : 'Continue'}
                                                                                        </button>
                                                                                    :
                                                                                    <button
                                                                                        className={`px-4 flex-1 py-2 rounded-md ${noRxSelected ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-[#10b981] text-white'}`}
                                                                                        disabled={noRxSelected}
                                                                                        onClick={() => {
                                                                                            if (noRxSelected) return;
                                                                                            setShowData(true);
                                                                                            setTimeout(() => {
                                                                                                const windowHeight = window.innerHeight;
                                                                                                const scrollAmount = windowHeight / 2;
                                                                                                window.scrollBy({ top: scrollAmount, behavior: "smooth" });
                                                                                            }, 100);
                                                                                        }}
                                                                                    >
                                                                                        Deliver
                                                                                    </button>
                                                                                }
                                                                            </div>
                                                                        );
                                                                    })()
                                                                }
                                                            </>
                                                        </PatientDetails>
                                                        {appointmentDelivery ? (
                                                            <DriverAppointmentCallPanel
                                                                patient={data}
                                                                appointmentDelivery={appointmentDelivery}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </React.Fragment>)
                                            })}
                            </div>

                            {
                                loadMore &&
                                <div className='flex mb-2'>
                                    <div className="loaderss"></div>
                                </div>
                            }

                        </div>

                        {showErrorToast && (
                            <Messages.DeliveryErrorMessages
                                setShowErrorToast={setShowErrorToast}
                                message={confirmDeliveryResponse?.userFacingErrorMessage}
                                onDismiss={() => dispatch(clearConfirmDeliveryUserMessage())}
                            />
                        )}
                        {showSuccessToast && <Messages.DeliverSuccessfull setShowToast={setShowSuccessToast} />}

                    </div>
                </div>
            </>
                : <PageNotFound />}
        </>
    )
}

export default VitalPatients
